import React from "react";
import style from "./style.module.scss"
import { useTheme } from "@material-ui/styles"
import { useSelector } from "react-redux"
import config from "../../config"

export default function ColumnChart({charts}){
  const { theme: { colors, borderColors } } = useTheme()
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const isContrast = themeState !== config.THEMES_MODES.LIGHT
  return (
    <div className={`${style.column}`}>
      {
        charts.map(
          c => (
            <div key={c.id} className={style.cell}>
              <div className={style.cols}>
                <div style={{height: `${c.firstCol.value}%`, width: "20px", backgroundColor: c.firstCol.color, border: isContrast ? `1px solid ${borderColors.borderPrimary100}` : 'none'}} className={style.col}/>
                <div style={{height: `${c.secondCol.value}%`,width: "20px", backgroundColor: c.secondCol.color, border: isContrast ? `1px solid ${borderColors.borderPrimary100}` : 'none'}} className={style.col}/>
                {c?.thirdCol ? <div style={{height: `${c.thirdCol.value}%`, backgroundColor: c.thirdCol.color, border: isContrast ? `1px solid ${borderColors.borderPrimary100}` : 'none'}}
                      className={style.col}/> : ""}
              </div>
              <p className={style.name} style={{ color: colors.colorText, borderTop: `3px solid ${borderColors.borderPrimary100}` }}>{c.name}</p>
            </div>
          )
        )
      }
    </div>
  )
}
